import { Component, Input, forwardRef, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-fa-select',
  templateUrl: './fa-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FASelectComponent),
      multi: true
    }
  ]
})
export class FASelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = '';
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
    }

    let url = `api/fixedassets/lookup?$top=20&$skip=0&$orderby=code asc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
